import React from 'react';
import { getPhotoUrl } from 'utils';

type DynamicPictureProps = {
	baseUrl: string;
	sizes: {
		tiny: {
			width: number;
			height: number;
		};
		small: {
			width: number;
			height: number;
		};
		medium: {
			width: number;
			height: number;
		};
		large: {
			width: number;
			height: number;
		};
	};
	imgCN?: string;
	pictureCN?: string;
	altText?: string;
};

export const DynamicPicture = ({
	baseUrl,
	sizes,
	imgCN,
	pictureCN,
	altText,
}: DynamicPictureProps) => {
	const url = getPhotoUrl(baseUrl);

	return (
		<picture className={pictureCN}>
			<source
				srcSet={`${url}.jpg?rmode=fit&width=${sizes.tiny.width}&height=${sizes.tiny.height}`}
				media="(max-width: 767px)"
			/>
			<source
				srcSet={`${url}.jpg?rmode=fit&width=${sizes.small.width}&height=${sizes.small.height}`}
				media="(max-width: 1023px)"
			/>
			<source
				srcSet={`${url}.jpg?rmode=fit&width=${sizes.medium.width}&height=${sizes.medium.height}`}
				media="(max-width: 1365px)"
			/>
			<img
				className={imgCN}
				src={`${url}.jpg?rmode=fit&width=${sizes.large.width}&height=${sizes.large.height}`}
				alt={altText}
				width="100%"
				height="100%"
			/>
		</picture>
	);
};

DynamicPicture.defaultProps = {
	imgCN: '',
	pictureCN: '',
	altText: '',
};
